import { render } from "./HeaderAbyachts.vue?vue&type=template&id=15a5b038&scoped=true"
import script from "./HeaderAbyachts.vue?vue&type=script&lang=js"
export * from "./HeaderAbyachts.vue?vue&type=script&lang=js"

import "./HeaderAbyachts.vue?vue&type=style&index=0&id=15a5b038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a5b038"]])

export default __exports__